import { ModalBase, NextImage } from "@jog/react-components";
import React from "react";
export const Modal = React.memo(ModalBase({
    modalBoxClass: "lg:pt-5 lg:px-7.5 lg:pb-7.5 min-h-[250px]",
    modalTitleClass: "font-primary font-bold text-sm",
    Close: (props) => (<button className="h-4 w-4 border-none bg-none xs:h-7.5 xs:w-7.5" {...props} aria-label="Close">
                <NextImage blur={false} src="/svgAsComponent/remove-item.svg" alt="" width="20" height="20"/>
            </button>),
}));
